'use client'

import GlobalStyles from '@mui/material/GlobalStyles'
import { useTheme } from '@mui/material/styles'

export function AuroraBackground() {
  const theme = useTheme()

  return (
    <>
      <GlobalStyles
        styles={{
          '@keyframes fly': {
            '100%': {
              transform: 'rotate(1turn) translate(100px) rotate(-1turn)'
            }
          },

          '@keyframes flyPlus': {
            '100%': {
              transform: 'rotate(-1turn) translate(100px) rotate(1turn)'
            }
          },

          '.wrapper': {
            width: '400px',
            height: '400px',
            background: '#fff',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '40px'
          },

          '.base': {
            position: 'absolute',
            filter: 'blur(60px)',
            opacity: '0.9'
          },

          '.one': {
            borderRadius: '100%',
            width: '600px',
            height: '600px',
            // backgroundColor: '#373372',
            backgroundColor: theme.palette.background.paper,
            left: '-50px',
            top: '-300px',
            zIndex: -9999,
            animation: 'fly 12s linear infinite',
            transform: 'rotate(0) translate(80px) rotate(0)'
          },

          '.two': {
            width: '500px',
            height: '800px',
            // backgroundColor: '#7C336C',
            backgroundColor: theme.palette.background.default,
            bottom: '30px',
            zIndex: -9999,
            left: '-80px'
          },

          '.three': {
            borderRadius: '100%',
            width: '450px',
            height: '450px',
            bottom: '80px',
            right: '100px',
            zIndex: -9999,
            // backgroundColor: '#B3588A',
            backgroundColor: theme.palette.background.paper,
            animation: 'flyPlus 17s linear infinite',
            transform: 'rotate(0) translate(100px) rotate(0)'
          }
        }}
      />

      <div style={{ overflow: 'hidden' }}>
        <div className="base one" />
        <div className="base two" />
        <div className="base three" />
      </div>
    </>
  )
}
